import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { makeStyles } from "@material-ui/core/styles";
import CTabel from "./CTabel";
import {
  getListOfCategories,
  deleteCategory,
} from "../../Services/admin/Category";
import { Pagination } from "@material-ui/lab";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { useDispatch } from "react-redux";
import { Button } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import swal from "sweetalert";

const useStyles = makeStyles((theme) => ({
  Btn: {
    borderRadius: 0,
    color: "#fff",
    backgroundColor: "#6DBCDB",
    "&:hover": {
      backgroundColor: "#0097e6",
    },
  },
}));

const Categories = ({ history }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(1);
  const classes = useStyles();
  const handleAddCategory = () => {
    const { push } = history;
    push("/CategoriesAdd");
  };
  const initRows = async (page) => {
    let { data } = await getListOfCategories(page);
    setCount(data.count);
    data = data.data;
    const tmp = [];
    data.map((val, idx) => {
      tmp.push({
        id: val._id,
        e_title: val.e_title,
        f_title: val.f_title,
        p_title: val.p_title,
        b_color: val.background,
        photo: val.photo,
      });
    });
    setRows(tmp);
  };
  const handleEdit = async (idx) => {
    const { push } = history;
    push({ pathname: "/CategoriesEdit", state: { info: rows[idx] } });
  };
  const handleRemove = async (id, name) => {
    let isSure = await swal({
      title: "Are you sure?",
      text: `Are you sure to delete ${name}!`,
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    });
    if (isSure) {
      try {
        dispatch(showLoading());
        await deleteCategory(id);
        swal("success!", "successfully category deleted!", "success");
        if (page == 1) await initRows(1);
        else setPage(1);
      } catch (error) {
        let msg = "some error occured";
        let { status, data } = error.response;
        if (status == 400 || status == 401) {
          msg = data.msg;
        }
        swal("wrong!", msg, "error");
      } finally {
        dispatch(hideLoading());
      }
    }
  };

  const handlePage = async (e, value) => {
    setPage(value);
  };
  useEffect(async () => {
    try {
      dispatch(showLoading());
      await initRows(page);
    } catch (error) {
      let msg = "some error occured";
      let { status, data } = error.response;
      if (status == 400 || status == 401) {
        msg = data.msg;
      }
      swal("wrong!", msg, "error");
    } finally {
      dispatch(hideLoading());
    }
  }, [page]);

  return (
    <>
      <Container>
        <Row>
          <Col md="3">
            <Button
              onClick={handleAddCategory}
              fullWidth
              variant="contained"
              className={classes.Btn}
            >
              + Add Category
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="mt-2">
            <CTabel
              rows={rows}
              handleRemove={handleRemove}
              handleEdit={handleEdit}
            />
          </Col>
        </Row>
        {count > 6 ? (
          <div className="mt-3">
            <Pagination
              count={parseInt((count + 5) / 6)}
              onChange={handlePage}
              page={page}
              style={{ display: "flex", justifyContent: "center" }}
              variant="outlined"
              color="secondary"
            />
          </div>
        ) : null}
      </Container>
    </>
  );
};

export default withRouter(Categories);
